// Purpose are matched with purpose name as there is no unique constants in backend (ids change across SIT, UAT, PROD)
// So purpose names across the servers should match with below values for additional fields to show
const purposeInputConfig = [
  {
    purposeName: "Missionary support",
    input1: {
      required: true,
      label: "Missionary Name",
      key: "missionaryName",
    },
    input2: {
      required: true,
      label: "Missionary Location",
      key: "missionaryLocation",
    },
  },
  {
    purposeName: "Specific project",
    input1: {
      required: true,
      label: "Project Name",
      key: "projectName",
    },
    input2: {
      required: false,
      label: "",
      key: "",
    },
  },
  {
    purposeName: "Underwriting cost of event",
    input1: {
      required: true,
      label: "Event Name",
      key: "eventName",
    },
    input2: {
      required: false,
      label: "",
      key: "",
    },
  },
];

export default purposeInputConfig;
